import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { AutoCompleteOptionType } from '../../../components/molecules/autocompleteTypes';
import Section from '../Section/Section';
import FilterAutoComplete from '../FilterAutoComplete/FilterAutoComplete';

const TRANSLATION_PREFIX = 'STATIC.PAGES.ANOMALY_ANALYSIS.FILTERS';

const excludeValue = (options, value) => (value ? options.filter(option => option.value !== value) : options);

const MetricsSection = ({ sizeOptions, colorOptions, filtersRef, onSizeChange, onColorChange }) => {
    const [selectedSize, setSelectedSize] = useState(() => filtersRef.current.sizeMetric);
    const [selectedColor, setSelectedColor] = useState(() => filtersRef.current.colorMetric);

    const handleSizeChange = useCallback(
        metric => {
            setSelectedSize(metric);
            filtersRef.current.sizeMetric = metric;
            onSizeChange(metric);
        },
        [filtersRef, onSizeChange]
    );

    const handleColorChange = useCallback(
        metric => {
            setSelectedColor(metric);
            filtersRef.current.colorMetric = metric;
            onColorChange(metric);
        },
        [filtersRef, onColorChange]
    );

    return (
        <>
            <Section
                icon="tag"
                labelKey={`${TRANSLATION_PREFIX}.SCALE_METRIC`}
                description={`${TRANSLATION_PREFIX}.SCALE_METRIC_DESCRIPTION`}
            >
                <FilterAutoComplete
                    options={excludeValue(sizeOptions, selectedColor?.value)}
                    value={selectedSize}
                    onChange={handleSizeChange}
                    label={`${TRANSLATION_PREFIX}.SELECT_METRIC`}
                />
            </Section>

            <Section
                icon="chart-line"
                labelKey={`${TRANSLATION_PREFIX}.PERFORMANCE_METRIC`}
                description={`${TRANSLATION_PREFIX}.PERFORMANCE_METRIC_DESCRIPTION`}
            >
                <FilterAutoComplete
                    options={excludeValue(colorOptions, selectedSize?.value)}
                    value={selectedColor}
                    onChange={handleColorChange}
                    label={`${TRANSLATION_PREFIX}.SELECT_METRIC`}
                    openUpward
                />
            </Section>
        </>
    );
};

MetricsSection.propTypes = {
    sizeOptions: PropTypes.arrayOf(AutoCompleteOptionType).isRequired,
    colorOptions: PropTypes.arrayOf(AutoCompleteOptionType).isRequired,
    filtersRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
    onSizeChange: PropTypes.func.isRequired,
    onColorChange: PropTypes.func.isRequired,
};

export default MetricsSection;
